// This is a fake client secret, but we pretend it is legit!
export const FAKE_CLIENT_SECRET = "sk_ivgZTALwUQgBh7AyzmzvUJ2"
